import { call, put, takeEvery } from 'redux-saga/effects';
import { CREATE_ACCOUNT_REQUEST } from '../constants/account.constants';
import { createAccountRequestSuccess, createAccountRequestFailure } from '../actions/account_actions/create_account.actions';
import { sendCreateAccountRequest } from '../../requests/account_requests';
import { message_success, message_error } from '../../../../components/Message';

function* createAccountRequest({
    login, password, first_name, last_name,
}) {
    const { result, msg } = yield call(sendCreateAccountRequest, login, password, first_name, last_name);
    if (result) {
        yield put(createAccountRequestSuccess());
        message_success('You should receive an email in the next few minutes. Please the link inside this link and verify your email.');
    } else {
        yield put(createAccountRequestFailure(msg));
        message_error(msg);
    }
}

export default function* createAccountSaga() {
    yield takeEvery(CREATE_ACCOUNT_REQUEST, createAccountRequest);
}



// WEBPACK FOOTER //
// ./src/modules/App/redux/sagas/create_new_account.saga.js